import { useState, useEffect } from "react";
import { DepotDropDown } from "src/components/DepotDropdown";
import { getAllGoodsInData, getAllGoodsInData1, setAllFilterDataToRedux } from "src/thunks/goodsin";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import _ from "lodash";
import { getMyData } from "src/thunks/auth";
import { toast } from "react-toastify";
import { GetError, getFloatValue } from "src/constant";
import { DashboardCalenderDropdown } from "src/components/dashboardCalenderDropdown";
import { getAllDispatchOrderData } from "src/thunks/dispatchOrder";
import IconClearFilter from "src/assets/images/icon_clearfilter.svg";
import IconRefreshList from "src/assets/images/icon_refreshlist.svg";
import SigmaLogo from "src/assets/images/S1GMA_Logo.svg"



function DashboardHeader({ RightSidebarOpenCloseFlag }) {
  const dispatch = useDispatch();
  const depoData = useSelector((state) => state?.depotUsers?.depoData || []);
  let userDetails = JSON.parse(localStorage.getItem("userDetails"))
  const currentDate = new Date();
  const last60Days = new Date(currentDate);
  last60Days.setDate(currentDate.getDate() - 60);


  useEffect(() => {
    getAllMyData()
  }, [])

  const getAllMyData = async () => {
    try {
      let res = await dispatch(getMyData()).unwrap();
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    } finally {
    }
  };

  const [depotDashboardDropdownValue, setDashboardDepotDropdownvalue] = useState({});
  const [isDepotDropdownOpenFlagValue, setIsDepotDropdownOpenFlagValue] = useState(false);
  const { signoutModelOpenFlag } = useSelector((state) => state.auth);
  const [valueFrom, setDateValueFrom] = useState(last60Days);
  const [valueTo, setDateValueTo] = useState(currentDate);
  const { filterAllData } = useSelector((state) => state.goodsin);



  const intOccupiedSpace = getFloatValue(_.sumBy(_.map(depoData || [], (d) => d.internalOccupiedSpace)));
  const extOccupiedSpace = getFloatValue(_.sumBy(_.map(depoData || [], (d) => d.externalOccupiedSpace)));
  const intAvailableSpace = getFloatValue(_.sumBy(_.map(depoData || [], (d) => d.internalAvailableSpace)));
  const extAvailableSpace = getFloatValue(_.sumBy(_.map(depoData || [], (d) => d.externalAvailableSpace)));

  const intDepotOccupiedSpace = getFloatValue(_.sumBy(_.map(userDetails?.depots || [], (d) => d.internalOccupiedSpace)));
  const extDepotOccupiedSpace = getFloatValue(_.sumBy(_.map(userDetails?.depots || [], (d) => d.externalOccupiedSpace)));

  const intDepotAvailableSpace = getFloatValue(_.sumBy(_.map(userDetails?.depots || [], (d) => d.internalAvailableSpace)));
  const extDepotAvailableSpace = getFloatValue(_.sumBy(_.map(userDetails?.depots || [], (d) => d.externalAvailableSpace)));

  useEffect(() => {
    let newData = filterAllData['dashboard']
    if ((userDetails?.roles == "SuperAdmin" || userDetails?.roles == "Admin")) {
      let findData = _.find(depoData, (d) => d.id === newData?.DepotIds[0] || 0)
      setDateValueFrom(newData?.from || last60Days)
      setDateValueTo(newData?.to || currentDate)
      if (findData) {
        setDashboardDepotDropdownvalue({ ...findData })
      } else {
        setDashboardDepotDropdownvalue({ name: "ALL DEPOTS", id: 0 })
      }
    } else {
      let findData = _.find(depoData, (d) => d.id === userDetails?.depots[0] || 0)
      setDateValueFrom(newData?.from || last60Days)
      setDateValueTo(newData?.to || currentDate)
      if (findData) {
        setDashboardDepotDropdownvalue({ ...findData })
      } else {
        setDashboardDepotDropdownvalue({ ...userDetails?.depots[0] })
      }
    }
  }, [])


  const handleDepotDropdownOpenChange = (value) => {
    setIsDepotDropdownOpenFlagValue(value);
  };

  const handleChange = (label) => {
    setDashboardDepotDropdownvalue(label);
  };
  const handleFromDateChange = (date) => {
    setDateValueFrom(date);
  };

  const handleToDateChange = (date) => {
    setDateValueTo(date);
  };

  const handleRefreshListButtonClick = async () => {
    try {
      let data = {
        isDateRange: true,
        from: moment(valueFrom).format("YYYY-MM-DD"),
        to: moment(valueTo).format("YYYY-MM-DD"),
        DepotIds: [depotDashboardDropdownValue?.id],
        ClientIds: [0],
        ProjectIds: [0],
      };

      const filterClone = _.cloneDeep(filterAllData)
      filterClone[`dashboard`] = { ...data }
      dispatch(setAllFilterDataToRedux({ ...filterClone }));
      localStorage.setItem('filterAllData', JSON.stringify(filterClone))

      await dispatch(getAllGoodsInData1({ ...data })).unwrap();
      await dispatch(getAllDispatchOrderData({ ...data })).unwrap();
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  };

  const handleClearFilterButtonClick = async () => {
    setDateValueFrom(last60Days);
    setDateValueTo(currentDate)
    if ((userDetails?.roles == "SuperAdmin" || userDetails?.roles == "Admin")) {
      setDashboardDepotDropdownvalue({ name: "ALL DEPOTS", id: 0 })
    } else {
      setDashboardDepotDropdownvalue({ ...userDetails?.depots[0] })
    }
    try {
      let data = {
        isDateRange: true,
        from: moment(last60Days).format("YYYY-MM-DD"),
        to: moment(currentDate).format("YYYY-MM-DD"),
        DepotIds: [(userDetails?.roles == "SuperAdmin" || userDetails?.roles == "Admin") ? 0 : userDetails?.depots[0]?.id],
        ClientIds: [0],
        ProjectIds: [0],
      };
      await dispatch(getAllGoodsInData1({ ...data })).unwrap();
      await dispatch(getAllDispatchOrderData({ ...data })).unwrap();
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  };



  return (
    <>
      {userDetails?.roles == "DepotManager" ? (
        // Depot manager dashboard
        <>
          <div
            className={`d-flex align-items-center main-header-div ${signoutModelOpenFlag == true ? "add-overlay-for-depot-dropdown" : ""
              }`}
          >
            <div style={{ height: "35px", width: "90px" }} className="ms-2">
              <img width={"100%"} height={"100%"} src={SigmaLogo} alt="muz image" />
            </div>

            <div
              className="d-flex text-uppercase"
              style={{
                flex: 0.7,
                color: "#FFFFFF",
                fontFamily: "Montserrat-medium",
                fontSize: 16,
              }}
            >
              <DashboardCalenderDropdown
                fromDate={valueFrom}
                handleFromDate={(date) => handleFromDateChange(date)}
                toDate={valueTo}
                handleToDate={(date) => handleToDateChange(date)} />
            </div>

            <div
              className="d-flex text-uppercase"
              style={{
                flex: 0.7,
                color: "#FFFFFF",
                fontFamily: "Montserrat-medium",
                fontSize: 16,
              }}
            >
              <DepotDropDown
                depoDataShown={userDetails?.depots}
                depotDropdownOpenFlag={isDepotDropdownOpenFlagValue}
                handleDepotDropdownOpenChange={(value) =>
                  handleDepotDropdownOpenChange(value)
                }
                handleChange={(value) => handleChange(value)}
                depotDashboardDropdownValue={depotDashboardDropdownValue}
              />
            </div>

            <div style={{ flex: 1.5, textAlign: "center" }}>
              {/* {RightSidebarOpenCloseFlag == false ? ( */}
              <>
                <span className="space-count-header-value">{depotDashboardDropdownValue?.name == "ALL DEPOTS" ? intDepotOccupiedSpace : depotDashboardDropdownValue?.internalOccupiedSpace}{" "} m<sup>2</sup> [INT] /{" "}</span><br />
                <span className="space-count-header-value">{depotDashboardDropdownValue?.name == "ALL DEPOTS" ? extDepotOccupiedSpace : depotDashboardDropdownValue?.externalOccupiedSpace}{" "} m<sup>2</sup> [EXT]</span>
              </>
              {/* ) : ( */}
              {/* <span className="space-count-header-value">
                  {depotDashboardDropdownValue?.name == "ALL DEPOTS" ? getFloatValue((intDepotOccupiedSpace + extDepotOccupiedSpace)) : getFloatValue(depotDashboardDropdownValue?.internalOccupiedSpace + depotDashboardDropdownValue?.externalOccupiedSpace)}
                </span>
              )} */}
              <span className="space-count-header-label">OCCUPIED</span>
            </div>
            <div
              className="space-count-header-value"
              style={{ flex: 1.5, textAlign: "center", paddingRight: 20 }}
            >
              {/* {RightSidebarOpenCloseFlag == false ? ( */}
              <>
                <span className="space-count-header-value">{depotDashboardDropdownValue?.name == "ALL DEPOTS" ? intDepotAvailableSpace : depotDashboardDropdownValue?.internalAvailableSpace}{" "} m<sup>2</sup> [INT] /{" "}</span><br />
                <span className="space-count-header-value">{depotDashboardDropdownValue?.name == "ALL DEPOTS" ? extDepotAvailableSpace : depotDashboardDropdownValue?.externalAvailableSpace}{" "} m<sup>2</sup> [EXT]</span>
              </>
              {/* ) : ( */}
              {/* <span className="space-count-header-value">
                  {depotDashboardDropdownValue?.name == "ALL DEPOTS" ? getFloatValue((intDepotAvailableSpace + extDepotAvailableSpace)) : getFloatValue((depotDashboardDropdownValue?.internalAvailableSpace + depotDashboardDropdownValue?.externalAvailableSpace))} &nbsp;m<sup>2</sup>

                </span>
              )} */}
              <span className="space-count-header-label">AVAILABLE</span>
            </div>
            <div
              onClick={handleClearFilterButtonClick}
              className="d-flex flex-column goodsin-text-color"
              style={{
                flex: 0.5,
                color: "#FFFFFF",
                fontSize: 9,
                fontFamily: "Montserrat-Regular",
                cursor: "pointer",
              }}
            >
              <img src={IconClearFilter} width={20} height={20} alt="clearfilters" />
              CLEAR FILTERS
            </div>
            <div
              onClick={handleRefreshListButtonClick}
              className="d-flex flex-column goodsin-text-color"
              style={{
                flex: 0.5,
                color: "#FFFFFF",
                fontFamily: "Montserrat-Regular",
                fontSize: 9,
                marginRight: 5,
                marginLeft: 5,
                cursor: "pointer",
              }}
            >
              <img src={IconRefreshList} width={20} height={20} alt="clearfilters" />
              REFRESH LIST
            </div>
          </div>
        </>

      ) : (
        //SuperAdmin Dashboard
        <div
          className={`d-flex align-items-center main-header-div ${signoutModelOpenFlag == true ? "add-overlay-for-depot-dropdown" : ""
            }`}
        >
          <div style={{ height: "35px", width: "90px" }} className="ms-2">
            <img width={"100%"} height={"100%"} src={SigmaLogo} alt="muz image" />
          </div>
          <div
            className="text-uppercase"
            style={{
              textAlign: "center",
              flex: 0.7,
              color: "#FFFFFF",
              fontFamily: "Montserrat-medium",
              fontSize: 14,
            }}
          >
            <DashboardCalenderDropdown
              fromDate={valueFrom}
              handleFromDate={(date) => handleFromDateChange(date)}
              toDate={valueTo}
              handleToDate={(date) => handleToDateChange(date)} />

          </div>
          <DepotDropDown
            depoDataShown={depoData}
            depotDropdownOpenFlag={isDepotDropdownOpenFlagValue}
            handleDepotDropdownOpenChange={(value) =>
              handleDepotDropdownOpenChange(value)
            }
            handleChange={(value) => handleChange(value)}
            depotDashboardDropdownValue={depotDashboardDropdownValue}
          />
          <div style={{ flex: 1.5, textAlign: "center" }}>
            {RightSidebarOpenCloseFlag == false ? (
              <>
                <span className="space-count-header-value">{depotDashboardDropdownValue?.name == "ALL DEPOTS" ? intOccupiedSpace : depotDashboardDropdownValue?.internalOccupiedSpace}{" "} m<sup>2</sup> [INT] /{" "}</span><br />
                <span className="space-count-header-value">{depotDashboardDropdownValue?.name == "ALL DEPOTS" ? extOccupiedSpace : depotDashboardDropdownValue?.externalOccupiedSpace}{" "} m<sup>2</sup> [EXT]</span>
              </>
            ) : (
              <span className="space-count-header-value">
                {depotDashboardDropdownValue?.name == "ALL DEPOTS" ? getFloatValue((intOccupiedSpace + extOccupiedSpace)) : getFloatValue((depotDashboardDropdownValue?.internalOccupiedSpace + depotDashboardDropdownValue?.externalOccupiedSpace))}
                &nbsp;m<sup>2</sup>
              </span>
            )}
            <span className="space-count-header-label">OCCUPIED</span>
          </div>
          <div
            className="space-count-header-value"
            style={{ flex: 1.5, textAlign: "center", paddingRight: 20 }}
          >
            {RightSidebarOpenCloseFlag == false ? (
              <>
                <span className="space-count-header-value">{depotDashboardDropdownValue?.name == "ALL DEPOTS" ? intAvailableSpace : depotDashboardDropdownValue?.internalAvailableSpace}{" "} m<sup>2</sup> [INT] /{" "}</span><br />
                <span className="space-count-header-value">{depotDashboardDropdownValue?.name == "ALL DEPOTS" ? extAvailableSpace : depotDashboardDropdownValue?.externalAvailableSpace}{" "} m<sup>2</sup> [EXT]</span>
              </>
            ) : (
              <span className="space-count-header-value">
                {depotDashboardDropdownValue?.name == "ALL DEPOTS" ? getFloatValue((intAvailableSpace + extAvailableSpace)) : getFloatValue((depotDashboardDropdownValue?.internalAvailableSpace + depotDashboardDropdownValue?.externalAvailableSpace))} &nbsp;m<sup>2</sup>
              </span>
            )}
            <span className="space-count-header-label">AVAILABLE</span>
          </div>
          <div
            onClick={handleClearFilterButtonClick}
            className="d-flex flex-column goodsin-text-color"
            style={{
              flex: 0.5,
              color: "#FFFFFF",
              fontSize: 9,
              fontFamily: "Montserrat-Regular",
              cursor: "pointer",
            }}
          >
            <img src={IconClearFilter} width={20} height={20} alt="clearfilters" />
            CLEAR FILTERS
          </div>
          <div
            onClick={handleRefreshListButtonClick}
            className="d-flex flex-column goodsin-text-color"
            style={{
              flex: 0.5,
              color: "#FFFFFF",
              fontFamily: "Montserrat-Regular",
              fontSize: 9,
              marginRight: 5,
              marginLeft: 5,
              cursor: "pointer",
            }}
          >
            <img src={IconRefreshList} width={20} height={20} alt="clearfilters" />

            REFRESH LIST
          </div>
        </div>
      )}
    </>
  );
}

export default DashboardHeader;
